export enum BrokerAutocompleteSectionIdEnum {
  location = 'location_id',
  broker = 'id',
}
